/**
 * Auto-generated from PHP DiamantReadySortBy enum.
 * Do not edit manually — run `pnpm sync-enums` to regenerate.
 */

export const DiamantReadySortBy = {
  Status: "status",
  Practitioner: "practitioner",
} as const;

export type DiamantReadySortBy =
  (typeof DiamantReadySortBy)[keyof typeof DiamantReadySortBy];
